import React from 'react'
import DataTable from './DataTable'

export default function DetailDataTable({ headerBackgroundColor = '#E1E6EC', ...props }) {
  return (
    <DataTable
      compact
      keepHeaderWhenEmpty
      headerBackgroundColor={headerBackgroundColor}
      {...props}
    />
  )
}
